<script lang="ts" setup>
import { PublicSellerWarrantyQuery } from '@gql/PublicSellerWarrantyQuery'

const t2 = useT2({})
const durationStr = useDurationTranslate()
const { seller, sellerId } = useSeller('server')

const { ui } = useApolloWrap2<gen.PublicSellerWarrantyQuery, gen.PublicSellerWarrantyQueryVariables>(PublicSellerWarrantyQuery)({
  vars() {
    const id = sellerId.value
    return id ? { sellerId: id } : undefined
  },
  ui: (i) => helpers.arr(i?.publicSellerWarranty),
})
</script>

<template>
  <AppMenu :title="t2('Warranty')">
    <template #content>
      <DocumentUi :document-id="seller?.doc?.warranty?._id" />
    </template>

    <InfoBoxes v-slot="{ item }" :items="ui" :ui="(i, index) => ({ key: index, title: i.title.value, description: durationStr(i.duration), hasContent: !!i.document?._id })">
      <DocumentUi :document-id="item.document?._id" />
    </InfoBoxes>
  </AppMenu>
</template>
